export enum CompanyStatus {
    live = 'live',
    offline = 'offline',
}
